import { useEffect, useState } from 'react';
import { PhoneCall, MessageCircle, ArrowUp } from 'lucide-react';
import { SITE, WHATSAPP_LINK } from '../lib/site';

/**
 * Barra de conversión fija en móvil: llamar + WhatsApp.
 * Se oculta al llegar al footer (evita solaparse con él).
 */
const StickyMobileBar = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const footer = document.querySelector('footer');
    if (!footer) return;
    const io = new IntersectionObserver(
      ([entry]) => setHidden(entry.isIntersecting),
      { rootMargin: '0px 0px -40px 0px' }
    );
    io.observe(footer);
    return () => io.disconnect();
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 inset-x-0 z-[85] transition-transform duration-300 ${
        hidden ? 'mobile-bar-hidden' : ''
      }`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)' }}
    >
      <div className="grid grid-cols-2 gap-px bg-paper border-t border-line">
        <a
          href={`tel:${SITE.phone}`}
          className="flex items-center justify-center gap-2 py-3.5 bg-ink text-paper text-[0.72rem] font-bold uppercase tracking-[0.14em] active:opacity-80 transition-opacity"
        >
          <PhoneCall size={16} className="text-clay-light" />
          Llamar
        </a>
        <a
          href={WHATSAPP_LINK('Hola, quiero un presupuesto.')}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 py-3.5 bg-clay text-white text-[0.72rem] font-bold uppercase tracking-[0.14em] active:opacity-80 transition-opacity"
        >
          <MessageCircle size={16} />
          WhatsApp
        </a>
      </div>
      {/* Pulgar hacia arriba */}
      <a
        href="#top"
        aria-label="Volver arriba"
        className="absolute -top-12 right-4 grid place-items-center w-11 h-11 rounded-full bg-ink text-paper border border-paper/20 shadow-lg"
      >
        <ArrowUp size={17} />
      </a>
    </div>
  );
};

export default StickyMobileBar;
